import './DmSignal.css';
import { checkDeviceLink } from '../../Utils/DateFormatter';
import { bars, signalLevels } from '../../Utils/Constants/SignalsLevels';

export default function DmSignal({signalValue, param_last_date, browserTime}) {

  const islink = checkDeviceLink(param_last_date, browserTime, 1) 
  ? 'Online' 
  : checkDeviceLink(param_last_date, browserTime, 5) ? 'Degraded' 
  : 'Offline';

let signalLevel=0;
let color = '#aba0a6cc'; // Цвет по умолчанию (серый для оффлайна)

      const currentSignal = signalLevels.find(({ min, max }) => signalValue >= min && signalValue <= max);
      if (currentSignal) {
        signalLevel = currentSignal.level;
        color = currentSignal.color;
      } 

    return(   
        <div className="signal">
            <div className='signalValue'>    
        {bars.map((height, index) => (
          <div
            key={index}
            className={`bar ${
            islink === 'Offline' 
                ? 'offline'
                : islink === 'Degraded'
                ? 'degraded'    
                : `level-${signalLevel}`
             }`}
            style={{
              height: `${signalLevel >= index + 1 ? height : 0}%`,
            }}
          ></div>
        ))}
            </div>
        </div>
    )
}